import {  computed } from 'vue'
import store from '../store'

const showPrices = computed(() => store.getters.showPrices)
const pricesVisibility = computed(() => showPrices.value === false ? 'hidden' : 'visible')
const pricesDisplay = computed(() => showPrices.value === false ? 'none' : 'inline')
const pricesTogglerVisibility = computed(() => showPrices.value === false ? 'visible' : 'hidden')
const pricesTogglerDisplay = computed(() => showPrices.value === false ? 'inline' : 'none')
const pricesTogglerPointer = computed(() => showPrices.value === false ? 'pointer' : 'auto')
const onPriceClick = (event) => {
  if(showPrices.value === false){
    event.target.nextElementSibling.classList.toggle('force-visible')
    event.target.classList.toggle('pi-eye')
    event.target.classList.toggle('pi-eye-slash')
  }
}

const showCosts = computed(() => store.getters.showCosts)
const costsVisibility = computed(() => showCosts.value === false ? 'hidden' : 'visible')
const costsDisplay = computed(() => showCosts.value === false ? 'none' : 'inline')
const costsTogglerVisibility = computed(() => showCosts.value === false ? 'visible' : 'hidden')
const costsTogglerDisplay = computed(() => showCosts.value === false ? 'inline' : 'none')
const costsTogglerPointer = computed(() => showCosts.value === false ? 'pointer' : 'auto')
const onCostClick = (event) => {
  if(showCosts.value === false){
    event.target.nextElementSibling.classList.toggle('force-visible')
    event.target.classList.toggle('pi-eye')
    event.target.classList.toggle('pi-eye-slash')
  }
}
export { 
  showPrices, pricesVisibility, pricesDisplay, pricesTogglerVisibility, pricesTogglerDisplay, pricesTogglerPointer, onPriceClick,
  showCosts, costsVisibility, costsDisplay, costsTogglerVisibility, costsTogglerDisplay, costsTogglerPointer, onCostClick
}